import { Route, Routes } from 'react-router';

import App from './app';
import {
  Browse,
  CaseOverview,
  Dashboard,
  DataValidation,
  Entity,
  Home,
  Login,
  QCBrowse,
  QCSummary,
  Transactions,

} from './views';

import {
  ProjectHandler,
  ProgramHandler,
  GraphiqlHandler,
} from './handlers';

const configureRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route element={<App />}>
        <Route index element={<Home />} />
        <Route path="graphiql" element={<GraphiqlHandler />} />
        <Route path=":program">
           <Route path=":project" element={<ProjectHandler />}>
            <Route path="transactions" element={<Transactions />} />
            <Route path="browse" element={<Browse />}>
                <Route path="data-validation" element={<DataValidation />} />
                <Route path="case-overview" element={<CaseOverview />} />
                <Route path=":entity" element={<Entity />} />
            </Route>
            <Route element={<QCBrowse />}>
              <Route path="qc" element={<QCSummary />} />
              <Route path="qc">
                <Route path=":entity" element={<Entity />} />
              </Route>
            </Route>
            <Route path="dashboard/*" element={<Dashboard />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};

export default configureRoutes;
